import isEmpty from "lodash/isEmpty";

import { Avatar, Text } from "@/ui/core";
import { BaseCard, HStack, StandardCardWidth, VStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface ProviderCarouselCardProps extends ViewWithTestID {
  fullName: string;
  pronouns?: string[];
  providerTypeName: string;
  userId?: string;
}

const ProviderCarouselCard = ({
  fullName,
  pronouns,
  providerTypeName,
  testID,
  userId,
}: ProviderCarouselCardProps) => {
  return (
    <BaseCard maxWidth={StandardCardWidth} testID={joinTestIDs(testID, "card")}>
      <VStack gap={12}>
        <Avatar
          size="md"
          testID={testID}
          userId={userId}
          userName={fullName}
          userType="provider"
        />
        <VStack gap={2}>
          <HStack alignItems="center" gap={6}>
            <Text
              testID={joinTestIDs(testID, "full-name")}
              variant="bodyMedium"
            >
              {fullName}
            </Text>
            {!isEmpty(pronouns) && (
              <Text testID={joinTestIDs(testID, "pronouns")} variant="caption">
                {pronouns}
              </Text>
            )}
          </HStack>
          <Text testID={joinTestIDs(testID, "type")} variant="caption">
            {providerTypeName}
          </Text>
        </VStack>
      </VStack>
    </BaseCard>
  );
};

export type { ProviderCarouselCardProps };
export default ProviderCarouselCard;
